<div class="list" *ngIf="total !== 0 || isLoading">
  <app-loader *ngIf="isLoading"></app-loader>
  <div><ng-content></ng-content></div>
  <div class="w-100 flex">
    <button
      #buttonElement
      class="button-round-large margin-xxl--left-auto margin-xxl--right-auto margin-xxl--top-16 margin-xxl--bottom-16"
      *ngIf="canLoadMore"
      (click)="onLoadMoreClick()"
    >
      Load More
    </button>
  </div>
</div>
<div *ngIf="total === 0 && !isLoading">
  <ng-content select="empty"></ng-content>
</div>
